import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
({
  selector: 'stepper-module-3',
  templateUrl: './module.3.html',
  styleUrls: ['./module.3.scss']
})

export class StepperModule3 implements OnInit 
{
  _guided_creation: GuidedCreation = null
  
  @Output() change: EventEmitter<number> = new EventEmitter<number>()

  constructor
  (
    private _util    : UtilsManager   ,
    private _notifier: NotifierManager,
    private _session : SessionManager 
  ) {}

  ngOnInit(): void
  {
    this.initObjects()
  }

  checkInput()
  {
    this.initObjects()

    if(!this._util.checker().isValidText(this._guided_creation.customName))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_CUSTOM_NAME)
      this.change.emit(0)
      return
    }

    if(!this._util.checker().isValidText(this._guided_creation.operatorName))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_OPERATOR_NAME)
      this.change.emit(0)
      return
    }


    //this._guided_creation.stima = (this._guided_creation.stima) ? "Y" : "N"

    this._session.guidedCreation().set(this._guided_creation)
    this.change.emit(1)

  }

  initObjects()
  {
    if(!this._guided_creation)
    {
      let object = this._session.guidedCreation().get() as GuidedCreation

      if(!isSessionCode(object)) this._guided_creation = object
      else this._guided_creation = new GuidedCreation()  
    }
  }
}
